module.exports = __webpack_public_path__ + "img/eyebrow_female_straight_thin.1e285897.png";